import { useState } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { PageContent } from '@/shared/components/PageContent';
import { DashboardHeader } from '@/features/dashboard/components/DashboardHeader';
import { DashboardSummary } from '@/features/dashboard/components/DashboardSummary/DashboardSummary';
import { DashboardMovements } from '@/features/dashboard/components/DashboardMovements/DashboardMovements';
import { useDashboardSummary } from '@/features/dashboard/hooks/useDashboard/useDashboardSummary';
import { useDashboardMovements } from '@/features/dashboard/hooks/useDashboard/useDashboardMovements';
import { t } from '@/i18n';


export default function DashboardPage() {
  const { userData, payload: authPayload } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  
  const { summary, userSpending, userDetails, customerDetails } = useDashboardSummary(authPayload?.user_uuid || "");
  const { data: movements, total } = useDashboardMovements( 
    authPayload?.customer_uuid || "", 
    currentPage,
    userData.role,
    authPayload?.user_uuid
  );

  const linkedAccount = {
    accountName: 'Agencia Active Media',
    clabe: '6461 2800 9111 0001',
    bankName: 'albo',
  };

  return (
    <PageContent
      header={
        <DashboardHeader
          userName={userDetails?.name || t('dashboard.welcome')}
          companyName={customerDetails?.legal_name || ''}
          companyId={customerDetails?.key_id || ''}
        />
      }
    >
      <div>
          <DashboardSummary 
            summary={summary} 
            userSpending={userSpending} 
            linkedAccount={linkedAccount}
          />
        
        <DashboardMovements 
          data={movements} 
          total={total} 
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      </div>
    </PageContent>
  );
}

export { DashboardPage };

